var $ = require('../modules/jquery');
var _isNil = require('lodash/isNil');

$(function () {
  if (!_isNil(Drupal) && !_isNil(Drupal.Ajax)) {
    Drupal.Ajax.prototype.setProgressIndicatorFullscreen = function () {
      this.progress.element = $('<div>').css({
        position: 'fixed',
        top: '50vh',
        left: '50vw'
      });
      this.progress.element.html('<svg class="progress progress--spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle cx="33" cy="33" r="30"></circle></svg>');
      $('body').after(this.progress.element);
    };
  }
});



//////////////////
// WEBPACK FOOTER
// ./web/themes/contrib/nccourts-theme/assets/src/js/components/ajax-throbber.js
// module id = 10
// module chunks = 5